define('companiesListController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'companiesListView',
  'entities/companies/companies'
], function (
  module,
  _,
  App,
  bootbox,
  View
) {
  'use strict';

  var CompaniesListController = {
    showCompaniesList: function () {
      var view = new View();

      this.view = view;
      view.listenTo(view, 'company:delete', _.bind(this.onDelete, this));
      App.regions.getRegion('main').currentView.getRegion('content').show(view);
    },

    onDelete: function (model) {
      bootbox.confirm(
        _.i18n('companies.confirmDelete', null,
          'Delete this company? The linked customers are kept and only detached from the company.'),
        _.bind(function (result) {
          if (result) {
            App.request('company:delete', model.get('secId')).done(_.bind(function () {
              this.view.refresh();
            }, this));
          }
        }, this));
    }
  };

  module.exports = CompaniesListController;
});

